import React, { Fragment } from "react";
import styled from "styled-components";
import { black700, curiousBlue300, royalBlue300 } from "../../theme/colors";
import {
  boldHeading,
  miniCaption,
  regularHeading,
} from "../../theme/typography";
import Card from "./Card";
import { semiBold } from "../../theme/typeface";
import themeSizes from "../../theme/themeSizes";



  export const formatMainText = (text) => {
    if (typeof text !== "string") return text;

    return text
      .split("/")
      .map((part) => {
        const num = parseFloat(part);
        return isNaN(num)
          ? part
          : num.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 0,
            });
      })
      .join("/");
  };

const RootCard = styled.div`
  margin: 16px 20px 14px;
  position: relative;
  z-index: 2;

  @media ${themeSizes.tablet} {
    margin: 14px 16px 12px;
  }

  @media ${themeSizes.mobile} {
    margin: 10px 14px 8px;
  }
`;

const MainText = styled.p`
  font-family: "barlow", sans-serif;
  font-weight: 800;
  font-size: 26px;
  margin: 0px;
  color: #1E2E4E;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  max-height: calc(1.2em * 2);
  word-break: break-word;

  @media ${themeSizes.tablet} {
    font-size: 22px;
  }

  @media ${themeSizes.mobile} {
    font-size: 20px;
  }
`;

const SubText = styled.p`
  font-family: "barlow", sans-serif;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  margin: 6px 0px 0px;
  color: ${(props) => props.subTextColor || "#64748B"};

  @media ${themeSizes.tablet} {
    font-size: 10px;
    letter-spacing: 0.5px;
  }

  @media ${themeSizes.mobile} {
    font-size: 9px;
    margin: 4px 0px 0px;
    letter-spacing: 0.5px;
  }
`;

const IndicatorGlow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  background: ${(props) => props.indicatorColor || "linear-gradient(180deg, #4770C1, #3E96C8)"};
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  z-index: 1;
`;

const IconCardStyle = styled.div`
  padding: 12px 18px 14px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  z-index: 2;

  @media ${themeSizes.tablet} {
    padding: 12px 14px;
  }

  @media ${themeSizes.mobile} {
    padding: 10px 14px;
  }
`;

const IconStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  line-height: 1;
  svg {
    width: 24px;
    height: 24px;
    color: ${royalBlue300};
  }

  @media ${themeSizes.mobile} {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
const TitleStyle = styled.p`
  margin: 0;
  width: 100%;
  ${regularHeading.mini}
  font-size: 18px;
  line-height: 1.25;
  font-weight: ${semiBold};

  @media ${themeSizes.tablet} {
    font-size: 16px;
  }

  @media ${themeSizes.mobile} {
    font-size: 13.5px;
  }
`;

const MainTextWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const Tooltip = styled.div`
  visibility: hidden;
  opacity: 0;
  width: max-content;
  max-width: 300px;
  background-color: ${black700};
  color: white;
  text-align: left;
  padding: 8px;
  border-radius: 4px;
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  margin-top: 4px;
  transition: opacity 0.3s;
  ${miniCaption.semiBold};
  white-space: pre-wrap;
`;

const HeaderCard = ({
  mainText = "0",
  subText = "Total No. of Users",
  onClick = () => false,
  clickable = false,
  subTextColor,
  iconCard,
  cardWidth = "285px",
  cardHeight = "100px",
}) => {

  return (
    <Card
      style={{ borderRadius: 12 }}
      width={cardWidth}
      height={cardHeight}
      onClick={onClick}
      clickable={clickable}
    >
      <IndicatorGlow clickable={clickable} />
      {iconCard ? (
        <IconCardStyle>
          <IconStyle>{mainText}</IconStyle>
          <TitleStyle>{subText}</TitleStyle>
        </IconCardStyle>
      ) : (
        <RootCard>
          <MainTextWrapper>
            <MainText>{formatMainText(mainText)}</MainText>
            <Tooltip className="tooltip">{formatMainText(mainText)}</Tooltip>
          </MainTextWrapper>
          {subText ? (
            <SubText subTextColor={subTextColor}>{subText}</SubText>
          ) : null}
        </RootCard>
      )}
    </Card>
  );
};

export default HeaderCard;